import { Link, usePage } from '@inertiajs/react';

import { NAV_GROUPS } from '@/data/navigation';

interface SidebarProps {
  adminStats?: { pendingMessages: number; pendingRequests: number };
}

export function Sidebar() {
  const { url, props } = usePage();
  const stats = (props as { adminStats?: SidebarProps['adminStats'] }).adminStats ?? {
    pendingMessages: 0,
    pendingRequests: 0,
  };

  return (
    <nav className="border-line bg-surface flex w-52 shrink-0 flex-col gap-0.5 border-r p-3">
      {NAV_GROUPS.map((group) => (
        <div key={group.label} className="flex flex-col gap-0.5">
          <p className="text-on-surface-light/70 px-3 pt-4 pb-1.5 text-[10px] font-bold tracking-widest uppercase">
            {group.label}
          </p>
          {group.items.map(({ to, label, icon, countKey }) => {
            const isActive = url === to || url.startsWith(to + '/');
            const count = countKey ? stats[countKey] : 0;
            return (
              <Link
                key={to}
                href={to}
                aria-current={isActive ? 'page' : undefined}
                className={`flex items-center gap-3 rounded-md px-3 py-2.5 text-sm transition-colors ${
                  isActive
                    ? 'bg-primary/10 text-primary font-semibold'
                    : 'text-on-surface-light hover:bg-background hover:text-on-surface font-medium'
                }`}
              >
                <span className="material-symbols-outlined text-[20px]">{icon}</span>
                {label}
                {count > 0 && (
                  <span className="bg-primary ml-auto inline-flex h-[18px] min-w-[18px] items-center justify-center rounded-full px-1.5 text-[11px] font-bold text-white">
                    {count}
                  </span>
                )}
              </Link>
            );
          })}
        </div>
      ))}
    </nav>
  );
}
